import { z } from 'zod';
export const HealthResponse = z.object({
    status: z.literal('ok'),
    service: z.string(),
    version: z.string(),
    uptimeSeconds: z.number().nonnegative(),
    time: z.iso.datetime(),
});
export const DependencyCheck = z.object({
    status: z.enum(['up', 'down']),
    latencyMs: z.number().nonnegative().optional(),
    error: z.string().optional(),
});
export const ReadyResponse = z.object({
    status: z.enum(['ready', 'not_ready']),
    checks: z.object({ database: DependencyCheck, redis: DependencyCheck }),
});
//# sourceMappingURL=health.js.map